export default __webpack_public_path__ + "static/safecheck-arrow-up-c02d658c2a25f1597eef97a7a8fbf01b.svg";